import React from 'react';
import Section, { FadeIn } from './ui/Section';
import SafeIcon from '../common/SafeIcon';

const Solution = () => {
  return (
    <Section>
      <div className="max-w-4xl mx-auto text-center mb-16">
        <FadeIn>
          <div className="inline-block bg-brand-yellow/10 text-brand-yellow font-bold px-4 py-2 rounded-full mb-4">
            THE SOLUTION
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 tracking-tight">
            Finally: A Decoder Ring for Relationship Language
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            <strong className="text-brand-dark">The 10 Most Dangerous Phrases in Relationships (Decoded)</strong> is your free guide to the moments that matter.
          </p>
        </FadeIn>
      </div>

      <FadeIn delay={0.2}>
        <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          <div className="bg-brand-dark p-6 text-white grid grid-cols-1 md:grid-cols-2 gap-4">
            <h3 className="font-bold text-lg uppercase tracking-wider text-brand-yellow">What You Get</h3>
            <h3 className="font-bold text-lg uppercase tracking-wider text-brand-yellow hidden md:block">Why It Matters</h3>
          </div>
          <div className="divide-y divide-gray-100">
            {[
              { get: "The phrase", matter: "\"I'm fine,\" \"do what you want,\" \"we need to talk\"" },
              { get: "What they actually mean", matter: "The real intent behind the words" },
              { get: "What you might hear", matter: "Why you keep getting it wrong" },
              { get: "The psychology", matter: "Why men and women speak differently" },
              { get: "Exactly what to say back", matter: "Scripts that stop fights before they start" }
            ].map((row, i) => (
              <div key={i} className="grid grid-cols-1 md:grid-cols-2 p-6 gap-2 md:gap-4 hover:bg-gray-50 transition-colors">
                <div className="font-semibold text-brand-dark flex items-center gap-3">
                  <SafeIcon name="CheckCircle" className="text-green-500 shrink-0" />
                  {row.get}
                </div>
                <div className="text-gray-600 md:pl-0 pl-8">{row.matter}</div>
              </div>
            ))}
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} className="text-center mt-16">
        <p className="text-2xl font-bold text-brand-dark">
          No more guessing. No more "what did they mean by that?"
        </p>
        <p className="text-xl text-gray-600 mt-2">
          Just clarity. Connection. And finally, being heard.
        </p>
      </FadeIn>
    </Section>
  );
};

export default Solution;